import { render, staticRenderFns } from "./LegacyProductsOverview.vue?vue&type=template&id=6bb16c50&scoped=true&"
import script from "./LegacyProductsOverview.vue?vue&type=script&lang=js&"
export * from "./LegacyProductsOverview.vue?vue&type=script&lang=js&"
import style0 from "./LegacyProductsOverview.vue?vue&type=style&index=0&id=6bb16c50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb16c50",
  null
  
)

export default component.exports